import type { MatchRule } from './matchRule';
import { identityRule } from './identityRule';
import { complementRule } from './complementRule';
import { additionRule } from './additionRule';
import { subtractionRule } from './subtractionRule';
import { mixedRule } from './mixedRule';

// Rule registry. Add a brain exercise by registering it here; modes and levels
// reference rules by id.
const REGISTRY = new Map<string, MatchRule>();

export function registerRule(rule: MatchRule): void {
  REGISTRY.set(rule.id, rule);
}

export function getRule(id: string): MatchRule {
  const rule = REGISTRY.get(id);
  if (!rule) throw new Error(`Unknown match rule: ${id}`);
  return rule;
}

export function listRules(): MatchRule[] {
  return [...REGISTRY.values()];
}

registerRule(identityRule);
registerRule(complementRule);
registerRule(additionRule);
registerRule(subtractionRule);
registerRule(mixedRule);

export type { MatchRule } from './matchRule';
